import type { Action } from 'svelte/action'

export const clickOutside: Action<
  HTMLElement,
  undefined,
  { onoutclick: (e: CustomEvent) => void }
> = (node) => {
  const handleClick = (event: MouseEvent) => {
    if (!node.contains(event.target as HTMLElement)) {
      node.dispatchEvent(new CustomEvent('outclick'))
    }
  }

  document.addEventListener('click', handleClick, true)

  return {
    destroy: () => document.removeEventListener('click', handleClick, true),
  }
}
